import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  buttonText: {
    textTransform: 'none'
  },
  buttonContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1)
  },
  button: {
    textTransform: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    borderColor: ({ focus }: { focus: boolean }) =>
      focus ? 'inherit' : theme.palette.grey[400]
  },
  icon: {
    marginLeft: theme.spacing(0.5)
  }
}));

export default useStyles;
